import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { atalhosMenuGerencial, itensNavegacaoModuloGerencial } from '../../core/rotas/navegacao-menu-gerencial';
import { LayoutModuloGerencialComponent } from '../../layout/layout-modulo-gerencial.component';
import { PainelDashboardGerencialComponent } from './painel-dashboard-gerencial.component';
import { ServicoSessaoGerencial } from './servico-sessao-gerencial';

@Component({
  selector: 'app-tela-menu-gerencial',
  standalone: true,
  imports: [CommonModule, LayoutModuloGerencialComponent, PainelDashboardGerencialComponent],
  templateUrl: './tela-menu-gerencial.component.html'
})
export class TelaMenuGerencialComponent implements OnInit, OnDestroy {
  agora = new Date();
  private atualizacaoRelogio?: number;

  constructor(readonly sessao: ServicoSessaoGerencial) {}

  get itensMenu() {
    return itensNavegacaoModuloGerencial('menu');
  }

  get atalhos() {
    return atalhosMenuGerencial();
  }

  ngOnInit() {
    this.sessao.carregar();
    this.atualizacaoRelogio = window.setInterval(() => this.agora = new Date(), 1000);
  }

  ngOnDestroy() {
    if (this.atualizacaoRelogio) {
      window.clearInterval(this.atualizacaoRelogio);
    }
  }
}
